var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreregAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 115,
    viewBox: "0 0 150 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.701 78.0319C124.833 73.0617 129.044 68.8576 134.022 65.7301C139.002 68.8595 143.216 73.0631 146.354 78.0319C143.22 83.0066 139.005 87.2141 134.022 90.3431C129.041 87.2152 124.83 83.0074 121.701 78.0319Z",
    fill: "url(#paint0_linear_1137_156038)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.128 96.2794C114.217 92.9644 117.025 90.1606 120.345 88.0751C123.669 90.1595 126.481 92.9634 128.572 96.2794C126.48 99.5914 123.672 102.395 120.355 104.484C117.033 102.397 114.221 99.5938 112.128 96.2794Z",
    fill: "#550065"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.136 96.4941C141.392 94.506 143.079 92.825 145.072 91.5752C147.063 92.8254 148.747 94.5064 149.999 96.4941C148.747 98.4817 147.063 100.163 145.072 101.413C143.079 100.163 141.392 98.4821 140.136 96.4941Z",
    fill: "#FF004C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7277 38.9876C21.0882 43.1378 17.5521 46.6458 13.3786 49.2547C9.20586 46.648 5.67246 43.1394 3.03882 38.9876C5.66587 34.8156 9.19975 31.2873 13.3786 28.6646C17.5582 31.2895 21.0947 34.8171 23.7277 38.9876Z",
    fill: "#550065"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7781 23.643C30.0234 26.423 27.6655 28.7739 24.8786 30.522C22.0923 28.7763 19.737 26.4248 17.9885 23.643C19.7394 20.8607 22.0941 18.5066 24.8786 16.7548C27.6639 18.5087 30.0213 20.8622 31.7781 23.643Z",
    fill: "url(#paint1_linear_1137_156038)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27372 23.4564C7.2215 25.1276 5.80595 26.5408 4.13212 27.5913C2.46309 26.5379 1.05129 25.1251 0 23.4564C1.05164 21.7905 2.46351 20.3809 4.13212 19.3309C5.80553 20.378 7.22115 21.7881 8.27372 23.4564Z",
    fill: "#FF004C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8649 57.4057C35.7969 37.0045 53.7792 19.0222 74.1803 4.09022C94.5663 19.0378 112.545 37.0166 127.493 57.4025C112.561 77.8037 94.5784 95.7859 74.1772 110.718C53.7667 95.799 35.7838 77.8161 20.8649 57.4057Z",
    fill: "#FF004C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4999 34.5834C62.8499 34.5834 52.5833 44.85 52.5833 57.5C52.5833 70.15 62.8499 80.4167 75.4999 80.4167C88.1499 80.4167 98.4166 70.15 98.4166 57.5C98.4166 44.85 88.1499 34.5834 75.4999 34.5834ZM75.4999 75.8334C65.3708 75.8334 57.1666 67.6292 57.1666 57.5C57.1666 47.3709 65.3708 39.1667 75.4999 39.1667C85.6291 39.1667 93.8333 47.3709 93.8333 57.5C93.8333 67.6292 85.6291 75.8334 75.4999 75.8334Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5001 48.3334C74.2344 48.3334 73.2084 49.3594 73.2084 50.625C73.2084 51.8907 74.2344 52.9167 75.5001 52.9167C76.7657 52.9167 77.7917 51.8907 77.7917 50.625C77.7917 49.3594 76.7657 48.3334 75.5001 48.3334Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5001 68.9584C76.7605 68.9584 77.7917 67.9271 77.7917 66.6667L77.7917 57.5C77.7917 56.2396 76.7605 55.2084 75.5001 55.2084C74.2397 55.2084 73.2084 56.2396 73.2084 57.5L73.2084 66.6667C73.2084 67.9271 74.2397 68.9584 75.5001 68.9584Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1137_156038",
    x1: 121.744,
    y1: 78.038,
    x2: 146.396,
    y2: 78.0446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1137_156038",
    x1: 24844.5,
    y1: 5357.54,
    x2: 24957.6,
    y2: 5470.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreregAlert);
export default __webpack_public_path__ + "static/media/preregAlert.1dd3a8d1479f176a3a28d4917a47576c.svg";
export { ForwardRef as ReactComponent };